"use client";

import HEADER_BRANDS from "@stadium/ui/src/components/brands/constants";
import ExternalButton from "@stadium/ui/src/components/button/external-button";
import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";

import defaultStyles from "@stadium/ui/src/components/brands/main.module.scss";

const WebBrands = ({ styles = defaultStyles, isNextImage = false }) => {
  const renderBrandLink = ({
    name,
    imgSrc,
    url,
    imgWidth,
    bannerBGClass,
    logoHoverBg,
    backgroundImg,
  }) => {
    const altText = name || "brand";

    return (
      <>
        <ExternalButton
          href={url}
          btnStyle="no-style"
          target="_blank"
          className={styles.WebBrandItem}
        >
          <div className={`${styles.webBrandItemLogo} ${logoHoverBg}`}>
            <Multimedia
              type="image"
              src={imgSrc}
              alt={altText}
              width={imgWidth}
              height={32}
              noBlur
              isNextImage={isNextImage}
            />
          </div>
        </ExternalButton>
        <div className={`${styles.webBrandItemImage} ${bannerBGClass}`}>
          <Multimedia
            type="image"
            src={backgroundImg}
            alt={altText}
            noBlur
            isNextImage={isNextImage}
            layout="responsive"
            objectFit="contain"
            objectPosition="bottom right"
          />
        </div>
      </>
    );
  };
  return (
    <div className={styles.webBrandContainerBG}>
      <div className={styles.webBrandContainerLarge}>
        <div className={styles.webBrandContainerSmall}>
          <div className={styles.webBrandItems}>
            <div className={styles.webBrandIteamHead}>1 Account, Many Brands</div>
          </div>
          <div className={styles.webBrandItemRow}>
            {HEADER_BRANDS({ styles }).map((brand) => (
              <div key={`brand-${brand.name}`} className={styles.webBrandItemCol}>
                {renderBrandLink(brand)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

WebBrands.propTypes = {
  styles: () => null,
  isNextImage: () => null,
};

export default WebBrands;
